import { initRevolugoDesignSystemWithClients } from '@revolugo/design-system/init-with-clients'

export default defineNuxtPlugin(nuxtApp => {
  initRevolugoDesignSystemWithClients(nuxtApp.vueApp)
})
